export const isStandalone = () => typeof window !== 'undefined' && window.parent === window;
